import React from 'react';
import tw from "twin.macro";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6 h-full`;
const Label = tw.label`absolute top-0 left-0 tracking-wide text-brand4  font-semibold text-sm`;
const Input = tw.input`placeholder-brand4`;
const TextArea = tw.textarea`h-24 sm:h-full resize-none placeholder-brand4`;
const SubmitButton = tw.button`w-full sm:w-32 mt-6 py-3 bg-brand5 text-brand1 rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-brand4 hover:text-brand1 hover:-translate-y-px hover:shadow-xl focus:-translate-y-px focus:shadow-xl`;
const encode = (data) =>
  Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join("&");


 const ContactUs = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const selectedEvent = urlParams.get("event") || "";
  const selectedWhen = urlParams.get("when") || "";
  const isBookingFlow = Boolean(selectedEvent);
  const selectedMessage = selectedEvent ? `Booking enquiry: ${selectedEvent}` : "";
  const sendEmail = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    if (process.env.NODE_ENV === "development") {
      toast("Form is configured. Netlify will collect submissions on deployed builds.", { type: 'info', theme: 'colored' });
      form.reset();
      return;
    }

    try {
      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode(data)
      });

      if (!response.ok) {
        throw new Error("Unable to submit form");
      }

      toast("Thank you so much for your email, we will be in touch!", { type: 'success', theme: 'colored' });
      form.reset();
    } catch (error) {
      toast("Error: Please try again!", { type: 'error', theme: 'colored' });
      console.log(error);
    }
  };

  return (
    <form name="contact" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" onSubmit={sendEmail}>
      <input type="hidden" name="form-name" value="contact" />
      <input type="hidden" name="bot-field" />
      <ToastContainer />
      <TwoColumn>
        <Column>
          <InputContainer>
            <Label htmlFor="name-input">Your Name</Label>
            <Input id="name-input" type="text" name="name-input" placeholder="John Doe" />
          </InputContainer>
          <InputContainer>
            <Label htmlFor="email-input">Your Email Address</Label>
            <Input id="email-input" type="email" name="email-input" placeholder="john@mail.com" />
          </InputContainer>
          {isBookingFlow && (
            <InputContainer>
              <Label htmlFor="event-input">Event</Label>
              <Input id="event-input" type="text" name="event-input" placeholder="Which event?" defaultValue={selectedEvent} />
            </InputContainer>
          )}
          {isBookingFlow && (
            <InputContainer>
              <Label htmlFor="number-of-ticket-input">Number of Ticket</Label>
              <Input id="number-of-ticket-input" type="number" min="1" name="number-of-ticket-input" placeholder="How many tickets?" />
            </InputContainer>
          )}
          <InputContainer tw="flex-1">
            <Label htmlFor="when-input">Date and Time</Label>
            <Input id="when-input" name="when-input" placeholder="When?" defaultValue={selectedWhen}/>
          </InputContainer>
        </Column>
        <Column>
          <InputContainer tw="flex-1">
            <Label htmlFor="message-input">Your Message</Label>
            <TextArea id="message-input" name="message-input" placeholder="Send us a message" defaultValue={selectedMessage}/>
          </InputContainer>
        </Column>
      </TwoColumn>

      <SubmitButton type="submit" value="Submit">Submit</SubmitButton>
    </form>
  );
};

export default ContactUs
